import type { AppModule } from '@/shared/types';

export const AdminModule: AppModule = {
};
